import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

/**
 * Auffangregel für Übersetzungen, die in der aktiven Sprache fehlen.
 *
 * Ohne Handler rendert ngx-translate den rohen Schlüssel — `calendar.tab_intervals`
 * statt „Intervalles". Das ist nicht nur unschön, sondern drei- bis viermal so
 * breit wie das echte Label und sprengt damit Layouts, die auf normale Wortlängen
 * ausgelegt sind (konkret aufgefallen an der Reiter-Leiste der Kalender-Dialoge).
 *
 * Der Handler macht aus dem letzten Pfadsegment einen lesbaren Namen:
 *   `calendar.tab_intervals` → `Tab intervals`
 *   `nutrition.meal-plan`    → `Meal plan`
 *
 * Bewusst ohne Sonderbehandlung struktureller Praefixe wie `tab_`: eine solche
 * Liste waere raterei und veraltet still. „Tab intervals" liest sich auf einem
 * Reiter holprig, ist aber lesbar und knapp — und genau darum geht es hier,
 * denn der Ersatz fuer den rohen Schluessel muss vor allem ins Layout passen.
 *
 * Bewusst KEIN `defaultLanguage: 'en'`: ngx-translate lädt dann zusätzlich die
 * komplette `en.json` (218 KB gegen 76 KB Locale-Datei) für jeden Nutzer außerhalb
 * von Deutsch. Das vervierfacht die i18n-Nutzlast, nur um dieselbe Lücke zu
 * kaschieren. Dieser Handler kostet nichts über die Leitung.
 *
 * Bewusst ohne Logging: fr/es/pt/pl fehlen je rund 2785 Schlüssel, eine Warnung
 * je Treffer würde die Konsole unbrauchbar machen. Fehlende Schlüssel gehören
 * über einen Abgleich der Locale-Dateien gefunden, nicht zur Laufzeit.
 */
export class HumanizeMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    return humanizeTranslationKey(params.key);
  }
}

/** Letztes Pfadsegment eines i18n-Schlüssels in lesbaren Text umwandeln. */
export function humanizeTranslationKey(key: string): string {
  if (!key) return key;

  const segment = key.slice(key.lastIndexOf('.') + 1);
  const words = segment.replace(/[_-]+/gu, ' ').trim();
  if (!words) return key;

  return words.charAt(0).toUpperCase() + words.slice(1);
}
